import React from 'react';
import { notification } from 'antd';
import './customNotification.css';

/* 
 NotificationType = 'success' | 'info' | 'warning' | 'error';
 */




export function openNotification(type, message, time) {
    const validTypes = ['success', 'error', 'info', 'warning'];
    const notificationType = validTypes.includes(type) ? type : 'info';

    const typeConfig = {
        success: { icon: <span className="icon-ok-modalpopup" style={{ color: 'green' }} /> },
        error: { icon: <span className="icon-error-modalpopup" style={{ color: 'red' }} /> },
        warning: { icon: <span className="icon-po-priorities" style={{ color: 'orange' }} /> },
        info: { icon: <span className="icon-tooltip" style={{ color: 'blue' }} /> },
    };

    const { icon } = typeConfig[notificationType];

    notification[notificationType]({
        message: <span style={{ fontWeight: 'bold' }}>{message}</span>,
        duration: time !== undefined ? time : 5,
        icon,
        closeIcon: <span className="icon-cancel-1" />,
        placement:'bottom'
    });
}